const resolveConcurrencyActions = value => ({
    updateConcurrency(nextConcurrencyData) {
        Object.assign(value, nextConcurrencyData);
    },
    disableFeature() {
        value.isEnabled = false;
    },
});

export default resolveConcurrencyActions;
